import { render, staticRenderFns } from "./SavedOffers.vue?vue&type=template&id=486a714a&scoped=true&"
import script from "./SavedOffers.vue?vue&type=script&lang=js&"
export * from "./SavedOffers.vue?vue&type=script&lang=js&"
import style0 from "./SavedOffers.vue?vue&type=style&index=0&id=486a714a&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "486a714a",
  null
  
)

export default component.exports